import { FieldErrors, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { UploadErrorMessage } from 'src/components/hook-form/UploadErrorMessage';
import RHFUploadImage from 'src/components/hook-form/uploadImage/RHFUploadImage';
import { FormInnerContainer, FormLabel } from 'src/layouts/form/FormLayout';

import { ImageState } from '../CategoryFormDialog';

interface IImagesInfoProps {
  images: ImageState;
  handleImageChange: (type: keyof ImageState) => (file: File | string | null) => void;
}

export const ImagesInfo = ({ images, handleImageChange }: IImagesInfoProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const imageFields = [
    {
      label: 'thumbnail',
      name: 'thumbnailPath',
      files: images.thumbnail ? [images.thumbnail] : [],
      onChange: handleImageChange('thumbnail'),
    },
    {
      label: 'bgDesktopPath',
      name: 'bgDesktopPath',
      files: images.desktop ? [images.desktop] : [],
      onChange: handleImageChange('desktop'),
    },
    {
      label: 'bgMobilePath',
      name: 'bgMobilePath',
      files: images.mobile ? [images.mobile] : [],
      onChange: handleImageChange('mobile'),
    },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
      {imageFields.map((field, idx) => {
        return (
          <CategoryImageUpload
            key={idx}
            label={field.label}
            name={field.name}
            files={field.files}
            onChange={(newFiles: Array<File | string>) => field.onChange(newFiles[0] || null)}
            errors={errors}
          />
        );
      })}
    </Box>
  );
};

interface ImageUploadProps {
  label: string;
  name: string;
  files: Array<File | string>;
  onChange: (files: Array<File | string>) => void;
  errors?: FieldErrors;
}

const CategoryImageUpload = ({ label, name, files, onChange, errors }: ImageUploadProps) => {
  const { t } = useTranslation();
  return (
    <FormInnerContainer>
      <FormLabel>{t(`category.form.${label}`)}</FormLabel>
      <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
        <RHFUploadImage
          name={name}
          files={files || []}
          onChange={onChange}
          accept={{ 'image/*': [] }}
          maxFiles={1}
        />
        {errors?.[name]?.message && (
          <UploadErrorMessage message={String(errors?.[name]?.message)} />
        )}
      </Box>
    </FormInnerContainer>
  );
};
